import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Select, Input, InputDate, Textarea } from 'components/fields'
import { Title } from 'components/misc'
import { mapCategories } from 'helpers/mapForSelect'
import { ACTIVITY_SECTIONS, CONFIGURATION_KEYS } from 'constants/enums'
import {
  SUBCATEGORIES,
  SUBCATEGORIES_INTL
} from 'constants/layout/setup-activity'
import Assessor from '../Assessor/Assessor'

@injectIntl
class Journey extends Component {
  static propTypes = {
    categoryValue: PropTypes.any,
    subcategoryValue: PropTypes.oneOf(PropTypes.number, PropTypes.string),
    setupAssessorId: PropTypes.number,
    minEndDate: PropTypes.any,
    aJCategories: PropTypes.object,
    codeLists: PropTypes.object,
    common: PropTypes.object,
    colorClass: PropTypes.string,
    intl: PropTypes.object,
    change: PropTypes.func.isRequired,
    transportationModeList: PropTypes.array,
    isAssessorManagementEnabled: PropTypes.bool
  }

  clearSubCategory = () => this.props.change('helpers.subcategory', null)
  clearOthers = () => this.props.change('helpers.others', null)

  render() {
    const {
      categoryValue,
      subcategoryValue,
      setupAssessorId,
      aJCategories,
      colorClass,
      minEndDate,
      codeLists,
      common,
      intl,
      transportationModeList,
      isAssessorManagementEnabled
    } = this.props

    const categories = get(
      aJCategories,
      `['${ACTIVITY_SECTIONS.adventurous_journey.id}'].categories`
    )
    const subCategories = get(
      aJCategories,
      `['${ACTIVITY_SECTIONS.adventurous_journey.id}'].subCategories`
    )

    const categoriesOptions = categories && mapCategories(categories)
    const subCategoriesOptions = subCategories && categoryValue
      ? mapCategories(subCategories[categoryValue])
      : []

    subCategoriesOptions.push(SUBCATEGORIES_INTL(intl))

    return (
      <div>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.activity_details"
            defaultMessage="Activity Details"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <Select
              options={categoriesOptions}
              name="helpers.category"
              label="Journey type"
              intlKey="label.journey_type"
              onChange={this.clearSubCategory}
            />
          </div>
        </div>

        {categoryValue &&
          <div className="row">
            <div className="col-xs-12">
              <Select
                options={subCategoriesOptions}
                name="activityCategory.id"
                label="Journey Activity"
                intlKey="label.journey_activity"
                onChange={this.clearOthers}
              />
            </div>
          </div>}

        {subcategoryValue === SUBCATEGORIES.others.value &&
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="helpers.others"
                label="Please specify your category"
                intlKey="label.specify_category"
              />
            </div>
          </div>}

        <div className="row">
          <div className="col-xs-12">
            <Input name="title" label="Name" intlKey="label.name" />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Select
              name="transportationModes"
              options={transportationModeList}
              label="Mode Of Transport"
              intlKey="label.mode_of_transport"
              backspaceToRemoveMessage={''}
              searchable
              multi
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Textarea
              rows={3}
              name="aim"
              label="Journey Objective"
              intlKey="label.journey_objective"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <InputDate
              name="startDate"
              label="Start Date"
              intlKey="label.start_date"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <InputDate
              name="endDate"
              label="End Date"
              intlKey="label.end_date"
              minDay={minEndDate}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="helpers.location"
              label="Location"
              intlKey="label.location"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Select
              label="Select country"
              intlKey="label.select_country"
              name="country.id"
              options={get(common, 'countries.list')}
              searchable
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Textarea name="note" label="Note" intlKey="label.note" />
          </div>
        </div>

        <Assessor
          colorClass={colorClass}
          titles={get(codeLists, 'titles.list')}
          subcategoryValue={subcategoryValue}
          setupAssessorId={setupAssessorId}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />

        <Assessor
          colorClass={colorClass}
          titles={get(codeLists, 'titles.list')}
          subcategoryValue={subcategoryValue}
          formPrefix="supervisor"
          sectionIntlKey="formTitle.supervisors_details"
          sectionTitle="Supervisor Details"
          promptIntlKey="label.select_award_unit_supervisor"
          promptDefault="Select from supervisors already approved by your Award Unit or create a new one below"
          disabledIntlKey="label.supervisor_disabled_for_other_activity"
          disabledDefault="Supervisor selection is disabled for other activity."
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />
      </div>
    )
  }
}

export default Journey
